<template>
  <div>
    <h2>活动</h2>

    <Divider>计划</Divider>

    <Table class="table" :columns="col1" :data="planData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="date">
        <span
          >{{ $moment(row.startTime).format("YYYY/MM/DD") }} -
          {{ $moment(row.endTime).format("YYYY/MM/DD") }}</span
        >
      </template>
      <template slot-scope="{ row }" slot="type">
        {{ row.type.join("、") }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" size="small" @click="edit(row)">修改</i-button>
        <i-button
          type="success"
          size="small"
          style="margin-left: 5px"
          @click="setHistory(row)"
          >设为历史</i-button
        >
      </template>
    </Table>

    <Button type="dashed" class="add-btn" @click="edit({})">添加</Button>

    <Divider>历史</Divider>
    <Table class="table" :columns="col1" :data="historyData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="date">
        <span
          >{{ $moment(row.startTime).format("YYYY/MM/DD") }} -
          {{ $moment(row.endTime).format("YYYY/MM/DD") }}</span
        >
      </template>
      <template slot-scope="{ row }" slot="type">
        {{ row.type.join("、") }}
      </template>

      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" size="small" @click="edit(row)">修改</i-button>
      </template>
    </Table>

    <Modal
      v-model="showEdit"
      title="计划添加/修改"
      @on-ok="save"
      @on-cancel="showEdit = false"
      width="720"
    >
      <Form :model="editObj" label-position="left" :label-width="100">
        <FormItem label="时间">
          <DatePicker
            :value="[editObj.startTime, editObj.endTime]"
            format="yyyy-MM-dd"
            @on-change="changeDate"
            type="daterange"
            placement="bottom-end"
            placeholder="选择竞赛时间"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="Type">
          <Select v-model="editObj.type" multiple placeholder="选择类型">
            <Option
              v-for="(option, index) in typeOptions"
              :value="option"
              :key="index"
              >{{ option }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="Position">
          <i-input type="text" v-model="editObj.position"></i-input>
        </FormItem>
        <FormItem label="Content">
          <i-input type="textarea" v-model="editObj.content"></i-input>
        </FormItem>
        <FormItem label="Detail">
          <Table class="table" :columns="col2" :data="editObj.details">
            <template slot-scope="{ row }" slot="number">
              {{ row._index + 1 }}
            </template>
            <template slot-scope="{ row }" slot="date">
              <span>{{ $moment(row.date).format("YYYY/MM/DD") }}</span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <i-button type="dashed" size="small" @click="editDetails(row)"
                >修改</i-button
              >
            </template>
          </Table>
          <Button type="dashed" class="add-btn" @click="editDetails({})"
            >添加</Button
          >
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="showEditDetails"
      title="修改添加details"
      @on-ok="saveDetails"
      @on-cancel="showEditDetails = false"
      width="520"
    >
      <Form :model="editDetailObj" label-position="left" :label-width="100">
        <FormItem label="时间">
          <DatePicker
            :value="editDetailObj.date"
            @on-change="changeDetailObjDate"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="Event">
          <i-input type="text" v-model="editDetailObj.event"></i-input>
        </FormItem>
        <FormItem label="Achievement">
          <i-input
            type="textarea"
            v-model="editDetailObj.achievement"
          ></i-input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      planData: {},
      historyData: {},
      col1: [
        {
          title: "No.",
          slot: "number",
          align: "center",
        },
        {
          title: "Date",
          slot: "date",
          align: "center",
        },
        {
          title: "Type",
          slot: "type",
          align: "center",
        },
        {
          title: "Position",
          key: "position",
          align: "center",
        },
        {
          title: "Content",
          key: "content",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],

      col2: [
        {
          title: "No.",
          slot: "number",
          align: "center",
          width: 80,
        },
        {
          title: "Date",
          slot: "date",
          align: "center",
          width: 120,
        },
        {
          title: "Event",
          key: "event",
          align: "center",
        },
        {
          title: "Achievement",
          key: "achievement",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],

      showEdit: false,
      editObj: {},
      typeOptions: ["Volunteer", "Academic", "Club"],

      showEditDetails: false,
      editDetailObj: {},
    };
  },
  methods: {
    async getPlanData(page = 1) {
      let res = await this.api({
        url: "/activity/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          isPast: 0,
        },
      });

      this.planData = res;
    },
    async getHistoryData(page = 1) {
      let res = await this.api({
        url: "/activity/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          isPast: 1,
        },
      });

      this.historyData = res;
    },

    edit(val) {
      this.editObj = val;
      this.showEdit = true;
    },
    async save() {
      await this.api({
        url: "/activity/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.editObj,
          student_id: this.$store.getters.selectedStudent._id,
          details: JSON.stringify(this.editObj.details),
          type: JSON.stringify(this.editObj.type),
        },
      });
      this.$Message.success("更新成功");
      this.showEditPlan = false;
      this.getPlanData();
      this.getHistoryData();
    },

    async setHistory(val) {
      await this.api({
        url: "/activity/setHistory",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          _id: val._id,
        },
      });

      this.$Message.success("更新成功");
      this.getPlanData();
      this.getHistoryData();
    },

    changeDate(val) {
      this.editObj.startTime = val[0];
      this.editObj.endTime = val[1];
    },

    editDetails(val) {
      this.editDetailObj = val;
      this.showEditDetails = true;
    },

    saveDetails() {
      let details = this.editObj.details || [];
      if (this.editDetailObj._index >= 0) {
        details[this.editDetailObj._index] = this.editDetailObj;
      } else {
        details.push(this.editDetailObj);
      }

      this.editObj.details = details;
      this.showEditDetails = false;
    },

    changeDetailObjDate(val) {
      this.editDetailObj.date = val;
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }

    this.getPlanData();
    this.getHistoryData();
  },

  watch: {
    "$store.getters.selectedStudent": function () {
      this.getPlanData();
      this.getHistoryData();
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  margin-top: 10px;
}

.add-btn {
  margin-top: 10px;
}
</style>